import { FC, useState } from 'react';
import { observer } from 'mobx-react';
import AppHeaderNotificationButton from '../../../../components/layouts/app-layout/app-header/header-notifications/app-header-notification-button';
import { NOTIFICATION_LINK_TYPE } from '../../../../components/layouts/app-layout/app-header/header-notifications/app-header-notification-link';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';
import dashboardSettingsStore from '../../../../stores/dashboard-settings-store';
import TermsAcceptanceModalBase from '../terms-acceptance-modal/terms-acceptance-modal-base';
import toastMessageListStore from '../../../../components/toast-messages-modal/toast-messages-store';
import { TOAST_VARIANTS } from '../../../../components/toast-messages-modal/toast-message/toast-message';

const TRANSLATION_SCOPE = 'dashboard-top-bar';

const TermsReviewNoticeModal: FC = observer(() => {
    const [isOpen, setIsOpen] = useState(false);
    const { getTranslation } = useDashboardTranslation();

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleAccept = async () => {
        await dashboardSettingsStore.acceptTerms();
    };

    const handleHeaderButtonClick = () => {
        if (dashboardSettingsStore.isSuperAdmin) {
            toastMessageListStore.add({
                title: getTranslation('TERMS_ACCEPTANCE_ADMIN_NOT_ALLOWED_TITLE', TRANSLATION_SCOPE),
                description: getTranslation('TERMS_ACCEPTANCE_ADMIN_NOT_ALLOWED', TRANSLATION_SCOPE),
                variant: TOAST_VARIANTS.ERROR,
            });
            return;
        }

        setIsOpen(true);
    };

    return (
        <>
            <AppHeaderNotificationButton
                type={NOTIFICATION_LINK_TYPE.INFO}
                text={getTranslation('REVIEW_TERMS_AND_CONDITIONS', TRANSLATION_SCOPE)}
                onClick={handleHeaderButtonClick}
            />
            {isOpen && (
                <TermsAcceptanceModalBase
                    termsContent={dashboardSettingsStore.termsContent!}
                    onAccept={handleAccept}
                    onClose={handleClose}
                />
            )}
        </>
    );
});

export default TermsReviewNoticeModal;
